export default "__VITE_ASSET__Cpyy04DL__"